<template>
  <section class="bidsRoot">
    <el-table
      v-if="isLoading || !bids.length"
      v-loading="isLoading"
      :data="[]"
      element-loading-text="Загрузка..."
    >
      <div slot="empty">
        <p v-if="!isError">В настоящее время погрузки отсутствуют</p>
        <template v-else>
          <p class="err-p"><b>Данные не загрузились</b></p>
          <el-button class="mob-btn" type="primary" @click="updatePage">
            Обновить
          </el-button>
        </template>
      </div>
    </el-table>
    <template v-else>
      <div>
        <div v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
          <bid-mobile
            v-for="(bid, i) in bids"
            :key="`${bid.id}_${i}`"
            :bid="bid"
            :freight="freights[bid.freight_id]"
            @set="setBid"
            @ready="onReady(bids, i)"
            v-on="$listeners"
          />
        </div>
        <loader-wrapper
          :loading="loadingInfinite"
          background="rgba(249,249,249,0)"
        >
          <div v-if="loadingInfinite" class="loader ta-c">Загрузка...</div>
        </loader-wrapper>
      </div>
      <el-dialog
        title="Координаты погрузки-выгрузки"
        width="100%"
        class="map-el-dialog"
        :visible.sync="dialog_bid_points"
      >
        <y-map :bid="current" />
      </el-dialog>
    </template>
  </section>
</template>

<script>
import { isBidViewed } from '@/helpers/visibilityOnScroll'
import { mapGetters } from 'vuex'
import BidMobile from './BidMobile'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import YMap from '@/components/Maps/YMap'

export default {
  name: 'BidsMobile',
  components: { BidMobile, YMap, LoaderWrapper },
  props: {
    bids: {
      type: Array,
      default: () => [],
    },
    freights: {
      type: Object,
      default: () => {},
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      current: {},
      dialog_bid_points: false,
      loadingInfinite: false,
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'bids/getLoading',
      isError: 'bids/isError',
      pagination: 'bids/getPagination',
      checkLibs: 'libs/checkLibs',
      getUnloadPointKladrId: 'bids/getUnloadPointKladrId',
    }),
    isLoading() {
      return this.getLoading('Bid') && !this.loadingInfinite
    },
    disabled() {
      return (
        this.page >= this.pagination?.pageCount || 1 || this.loadingInfinite
      )
    },
  },
  methods: {
    load() {
      if (!this.loadingInfinite) {
        this.loadingInfinite = true
        this.$emit('page', this.page + 1)
        this.fetchBids(true, () => (this.loadingInfinite = false))
      }
    },
    updatePage() {
      this.fetchBids()

      if (!this.checkLibs) {
        this.$store.dispatch('libs/setLibs')
      }
      if (!this.getDocumentTypes.length) {
        this.$store.dispatch('documentTypes/init')
      }
    },
    onReady(bids, i) {
      if (i === bids.length - 1) {
        isBidViewed(this, '.infinite-wrap')
      }
    },
    fetchBids(isLoad, callback) {
      this.$emit('fetch', { isLoad, callback })
    },
    setBid(bid, key) {
      this.current = bid
      this[key] = true
    },
  },
}
</script>

<style lang="sass" scoped>
@import "~@/assets/styles/mixins.sass"

.bidsRoot
  padding: 0 5px
  margin-top: 250px
  @include from(401px)
    margin-top: 170px
  .el-radio-group
    width: 100%
  .el-radio-button
    width: 100%
    display: grid
    .el-radio-button__inner
      width: 100%
  .bM_div
    display: flex
    flex-direction: column
    margin-bottom: 10px
  .bM_row
    margin: 0 0 10px!important
</style>
